(function () {
  document.querySelectorAll('.nt-hero').forEach(function (hero) {
    var slides = hero.querySelectorAll('.nt-hero__slide');
    var dots = hero.querySelectorAll('.nt-hero__dot');
    var prevBtn = hero.querySelector('[data-nt-hero-prev]');
    var nextBtn = hero.querySelector('[data-nt-hero-next]');
    if (slides.length < 2) return;

    var current = 0;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(hero.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || reduceMotion) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
})();
